import { DriverType, IUserJobWrite } from "./types";

export const jobInitialState: IUserJobWrite = {
  subCategory: "",
  jobDate: "",
  assignedTo: "",
  description: "",
  actionsLinked: [],
  otherTaskItems: [],
  status: "",
  driverType: DriverType.INTERNAL,
  vehicleEvent: {
    id: "",
    vehicle: "",
    odometerReadingAtStart: 0,
    odometerReadingAtEnd: 0,
    odometerReadingAtStartImg: "",
    odometerReadingAtEndImg: "",
    eventStartDateTime: "",
    eventEndDateTime: "",
    isBillable: false,
    usedBy: ""
  }
}